/**
 * The Kimene mark, copied from the console's `web/src/components/Logo.tsx`.
 *
 * A monogram K built as a routing junction: a stem and two arms converging on a
 * single bright node — the decision, the one place that glows, and the answer to
 * the question the name itself asks ("kime?" — to whom does this work route?).
 *
 * Copied rather than imported for the same reason `base.css` is: this page takes
 * exactly one file from `web/`, and it is the palette. The mark changes when the
 * brand changes, which is not often and is not silently.
 *
 * Gradient ids are per-instance because several marks can share a page and
 * duplicate SVG ids cross-reference.
 */
import { useId } from 'react'

export function Logo({ size = 28, className }: { size?: number; className?: string }) {
  const uid = useId().replace(/[^a-zA-Z0-9]/g, '')
  const plate = `kplate-${uid}`
  const glow = `kglow-${uid}`
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      aria-hidden
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id={plate} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#121a22" />
          <stop offset="1" stopColor="#0a0f15" />
        </linearGradient>
        <radialGradient id={glow} cx="11" cy="16" r="15" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#9ff2e0" />
          <stop offset="0.5" stopColor="#4dd8c0" />
          <stop offset="1" stopColor="#2f9585" />
        </radialGradient>
      </defs>
      <rect x="1" y="1" width="30" height="30" rx="8.5" fill={`url(#${plate})`} stroke="#2a5a54" />
      <g
        fill="none"
        stroke={`url(#${glow})`}
        strokeWidth="2.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M11 7.5 V24" />
        <path d="M22 8.5 L13.5 16" />
        <path d="M13.5 16 L22.5 24" />
      </g>
      <rect
        x="12.6"
        y="14.6"
        width="2.8"
        height="2.8"
        rx="0.6"
        transform="rotate(45 14 16)"
        fill="#bff6ea"
      />
    </svg>
  )
}
